const CollapsibleLeftNavComponent = {
    templateUrl: '/ui/collapsibleLeftNav/collapsibleLeftNav.tpl.html',
    controller: 'collapsibleLeftNavController',
    transclude: true,
    bindings: {
        collapsible: '<'
    }
};

angular.module('umCore')
    .component('uiCollapsibleLeftNav', CollapsibleLeftNavComponent);
